"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Clear_1 = __importDefault(require("@mui/icons-material/Clear"));
const Search_1 = __importDefault(require("@mui/icons-material/Search"));
const material_1 = require("@mui/material");
const zustandStore_1 = require("../../../../zustandStore");
const SearchApprovals = () => {
    const searchValue = (0, zustandStore_1.useZustand)(state => state.approvals.searchValue);
    const { setSearchApprovalsValue } = (0, zustandStore_1.useZustand)();
    const theme = (0, material_1.useTheme)();
    return ((0, jsx_runtime_1.jsx)(material_1.TextField, { "data-testid": "search-approvals", type: "text", value: searchValue, onChange: event => setSearchApprovalsValue(event.target.value), placeholder: "Search by description", variant: "outlined", size: "small", style: { padding: 0 }, sx: {
            '.MuiInputBase-input.MuiOutlinedInput-input': {
                padding: 0,
            },
        }, slotProps: {
            input: {
                style: { paddingLeft: theme.tsGoUnit.tsUnitQuarter, backgroundColor: theme.palette.tsGoColor.white },
                startAdornment: ((0, jsx_runtime_1.jsx)(material_1.InputAdornment, { position: "start", children: (0, jsx_runtime_1.jsx)(Search_1.default, {}) })),
                endAdornment: searchValue && ((0, jsx_runtime_1.jsx)(material_1.InputAdornment, { position: "end", onClick: () => setSearchApprovalsValue(''), style: { cursor: 'pointer' }, children: (0, jsx_runtime_1.jsx)(Clear_1.default, {}) })),
            },
        } }));
};
exports.default = SearchApprovals;
